import { render, staticRenderFns } from "./PagoInforme.vue?vue&type=template&id=9f990e6a&scoped=true"
import script from "./PagoInforme.vue?vue&type=script&lang=js"
export * from "./PagoInforme.vue?vue&type=script&lang=js"
import style0 from "./PagoInforme.vue?vue&type=style&index=0&id=9f990e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f990e6a",
  null
  
)

export default component.exports